import { render, staticRenderFns } from "./CompanyResetPassword.vue?vue&type=template&id=74a07d4c&scoped=true&"
import script from "../../services/company/company-reset-password.js?vue&type=script&lang=js&"
export * from "../../services/company/company-reset-password.js?vue&type=script&lang=js&"
import style0 from "@/assets/css/company.css?vue&type=style&index=0&id=74a07d4c&scoped=true&lang=css&"
import style1 from "./CompanyResetPassword.vue?vue&type=style&index=1&id=74a07d4c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74a07d4c",
  null
  
)

export default component.exports